import { createSelector } from '@reduxjs/toolkit'

import { Discount, DiscountType, DiscountUnit } from 'common/billing/entities/cart/interfaces'
import { ProInfo } from 'common/billing/interfaces/billing'

const getBillingProInfo = (state: RootState): ProInfo => state.billing.pro

export const getAppliedDiscount = createSelector([getBillingProInfo], (info): Discount | null => {
  const coupon = info.coupon

  if (coupon) {
    return {
      type: DiscountType.COUPON,
      period: coupon.period,
      periodUnit: coupon.type,
      discount: coupon.percentage_discount_amount_value,
      discountUnit: DiscountUnit.PERCENT,
      plans: coupon.products || [],
      addOns: coupon.addons || [],
      coupon,
    }
  }

  return null
})
